import React from "react"
import { Link } from "react-router-dom"
import { Mutation } from "react-apollo"
import LOGOUT from "../../graphql/logout.graphql"
import Toggle from "react-toggle"
import useToggle from "../../hooks/useToggle"
import gql from "graphql-tag"

import "./accountLinks.scss"

const SET_EXCLUDE_RESPONDENTS_VIEW = gql`
  mutation SET_EXCLUDE_RESPONDENTS_VIEW($excludeRespondents: Boolean!) {
    setExcludeRespondentsView(excludeRespondents: $excludeRespondents) {
      success
      message
      user {
        id
        excludeRespondents
      }
    }
  }
`

const AccountLinks = (props) => {
  const { viewer } = props

  const [isExcludeRespondentsView, toggleIsExcludeRespondentsView] = useToggle(
    viewer.excludeRespondents
  )

  const isAdmin = viewer.roles.find((role) => role.includes("Admin"))

  const links = [
    {
      to: "/account",
      icon: "glyphicon glyphicon-user",
      children: "Your Account",
    },
  ]

  return (
    <div className="account-links-container">
      {links.map(({ icon, ...link }, i) => (
        <div key={i} className="link">
          <span className={icon} />
          <Link {...link} onClick={props.close} />
        </div>
      ))}

      {isAdmin ? (
        <Mutation mutation={SET_EXCLUDE_RESPONDENTS_VIEW}>
          {(mutate) => {
            const onExcludeRespondentsViewToggle = async () => {
              toggleIsExcludeRespondentsView()

              try {
                const resp = await mutate({
                  variables: {
                    excludeRespondents: !isExcludeRespondentsView,
                  },
                })

                if (
                  resp &&
                  resp.data &&
                  resp.data.setExcludeRespondentsView &&
                  resp.data.setExcludeRespondentsView.success
                ) {
                  window.location.reload()
                }
              } catch (e) {
                console.log("Error while trying to update view.")
              }
            }

            return (
              <div className="exclude-respondents-view-toggle">
                <span>Government Custom Compliance</span>
                <span>
                  <Toggle
                    className="exclude-respondents-toggle"
                    defaultChecked={viewer.excludeRespondents}
                    icons={false}
                    onChange={onExcludeRespondentsViewToggle}
                  />
                </span>
              </div>
            )
          }}
        </Mutation>
      ) : null}

      <div className="link bottom" onClick={props.logout}>
        <span className="glyphicon glyphicon-off" />
        <span className="sign-out">Log Out</span>
      </div>
    </div>
  )
}

const AccountLinksWithData = (props) => (
  <Mutation mutation={LOGOUT}>
    {(mutate) => {
      const logout = () => {
        props.close()
        mutate()
          .then(() => props.history.replace("/"))
          .then(() => props.close())
      }

      return <AccountLinks {...props} logout={logout} />
    }}
  </Mutation>
)

export default AccountLinksWithData
